import React from 'react';
import Form from './components/Form';
import './components/Form.css'; // Import the CSS file
import logo from './assets/SATHYA-SAI-BABA-WRITING-TO-STUDENTS.jpg'; // Import the image file

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="header">
        <img src={logo} alt="Logo" className="logo" />
        <h1 className="heading">Sai Samarpan Article Upload Form</h1>
      </header>
      <Form />
    </div>
  );
};

export default App;